export const autoCompleteTranslationJP = {
  autoCompleteTranslation: {
    loading: 'データ取り込み中',
    no_options: 'オプションなし',
  },
};
